import { html } from 'lit';
import { Star } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-star')
export class PdsIconStar extends PdsIcon {
  @state()
  icon = Star;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
